import React from "react";

//Component===============================
import Card from "components/Card/Card.jsx";
import CardBody from "components/Card/CardBody.jsx";

import GridContainer from "components/Grid/GridContainer.jsx";
import GridItem from "components/Grid/GridItem.jsx";

import FormLabel from "@material-ui/core/FormLabel";
import TextField from '@material-ui/core/TextField';
import CustomInput from "components/CustomInput/CustomInput.jsx";
import Button from "components/CustomButtons/Button.jsx";
import FormControl from "@material-ui/core/FormControl";
import InputLabel from "@material-ui/core/InputLabel";
import Select from "@material-ui/core/Select";
import MenuItem from "@material-ui/core/MenuItem";

//ICON ===============================
import SaveIcon from "@material-ui/icons/Save";
import PriorityHighIcon from "@material-ui/icons/PriorityHigh";

import ConfigHost from "ConfigHost"
import {thaiBath} from "ConvertFormat"

import { API } from "API"
import { APIGet,APIPost } from "APIRequest"

import UrlServer from "UrlServer"
import * as Alert from "alertService"

//Style===============================
import withStyles from "@material-ui/core/styles/withStyles";
// import loginPageStyle from "assets/jss/material-dashboard-pro-react/views/loginPageStyle.jsx";
import regularFormsStyle from "assets/jss/material-dashboard-pro-react/views/regularFormsStyle";

const styles = {
    ...regularFormsStyle,
    container2: {
        paddingLeft: 16,
        paddingRight: 16,
        display: 'flex',
        flexWrap: 'wrap',
    },
    container: {
      display: 'flex',
      flexWrap: 'wrap',
    },
    dense: {
      marginTop: 16,
    },
    menu: {
      width: 200,
    },
    marginRight: {
        float: "right !important"
    },
}
class SetAmountTargetPage extends React.Component {
    constructor(props) {
        super(props)
        this.state = {
          supLists:[],
          supID:0,
          yearLists:[],
          yearID:0,
          datasInput:this.getDefaultDatas(),
          dataWaitToSave:false
        }
      }
    componentDidMount(){
        Alert.Loading()
        // API("GET",UrlServer.URL_SETTINGAMOUNTTARGET_GETLISTSSUPERVISOR,null,({datas})=>{
        APIGet(UrlServer.URL_SETTINGAMOUNTTARGET_GETLISTSSUPERVISOR,({datas})=>{
            this.setState({supLists:datas})
            // API("GET",URL.URL_SETTINGAMOUNTTARGET_GETLISTSYEAR,null,({datas})=>{
            APIGet(UrlServer.URL_SETTINGAMOUNTTARGET_GETLISTSYEAR,({datas})=>{
                this.setState({yearLists:datas},()=>{
                    Alert.LoadingClose()
                })
            })
        })
    }

    renderSupLists = ()=> {
        return this.state.supLists.map((data,index)=>{
            return  <MenuItem
                        key = {data.parentID+"-"+index}
                        classes={{
                            root: this.props.classes.selectMenuItem,
                            selected: this.props.classes.selectMenuItemSelected
                        }}
                        value={data.parentID}
                        >
                        {"ID " + data.parentID + " : " + data.FName + " " + data.LName}
                    </MenuItem>
        })
    }
    renderYearLists = ()=> {
        return this.state.yearLists.map((data,index)=>{
            return  <MenuItem
                        key = {data.yearID+"-"+index}
                        classes={{
                            root: this.props.classes.selectMenuItem,
                            selected: this.props.classes.selectMenuItemSelected
                        }}
                        value={data.yearID}
                        >
                        {"พ.ศ. " + data.name}
                    </MenuItem>
        })
    }
    handleChange = (name,val) => {
        // console.log(name+" : "+val);
        this.setState({
            [name]: val,
        });
    };
    handleChangeName = event => {
        // console.log(event.target.name,event.target.value );
        this.setState({ 
            [event.target.name]: event.target.value ,
            dataWaitToSave:false
        },()=>{
            if(this.state.yearID && this.state.supID){
                this.getDatasSelect()
            }
        });

    };
    handleChangeTarget = (name,index,val) => {
        // console.log(event.target.name,event.target.value );
        var datasInput = this.state.datasInput;
        datasInput[index][name] = parseInt(val) 
        this.setState({ 
            datasInput: datasInput,
            dataWaitToSave:true
        },()=>{
        });

    };
    getDatasSelect = ()=> {
        // console.log("getDatasSelect");
        Alert.Loading()
        // API("GET",URL.URL_SETTINGAMOUNTTARGET_GETLISTSDATAS+this.state.supID+"/"+this.state.yearID,null,({datas})=>{
        APIGet(URL.URL_SETTINGAMOUNTTARGET_GETLISTSDATAS+this.state.supID+"/"+this.state.yearID,({datas})=>{
            // console.log(JSON.stringify(datas));
            Alert.LoadingClose()
            if(datas.length > 0){
                this.setState({datasInput:datas})
            }else{
                this.setState({datasInput:this.getDefaultDatas()})
            }
        })
    }
    getDefaultDatas = ()=> {
        var datas = []
        for (let index = 1; index <= 12; index++) {
            datas.push({
                monthID: index,
                amount_1: 0,
                amount_2: 0
            })
        }
        return datas
    }
    convertMonth = (M_ID)=> {
        switch (M_ID) {
            case 1:
                return "มกราคม"
            case 2:
                return "กุมภาพันธ์"
            case 3:
                return "มีนาคม"
            case 4:
                return "เมษายน"
            case 5:
                return "พฤษภาคม"
            case 6:
                return "มิถุนายน"
            case 7:
                return "กรกฎาคม"
            case 8:
                return "สิงหาคม"
            case 9:
                return "กันยายน"
            case 10:
                return "ตุลาคม"
            case 11:
                return "พฤศจิกายน"
            case 12:
                return "ธันวาคม"
            default:
               return "ID ไม่ตรง...";
        }
    }
    saveAmountTarget = ()=>{
        if(this.state.yearID && this.state.supID){
            if(!this.state.dataWaitToSave){
                Alert.WarningCallback("ข้อมูลยังไม่มีการเปลี่ยนแปลง")
            }else{
                Alert.Loading(true)

                var datasForSendToSave = {
                    yearID:this.state.yearID,
                    userID:this.state.supID,
                    datas:this.state.datasInput
                }
                // API("POST",URL.URL_SETTINGAMOUNTTARGET_SET_AMOUNTTARGET_BY_SUPERVISOR,datasForSendToSave,({datas})=>{
                APIPost(URL.URL_SETTINGAMOUNTTARGET_SET_AMOUNTTARGET_BY_SUPERVISOR,datasForSendToSave,({datas})=>{
                    this.setState({dataWaitToSave:false},()=>{
                        // this.getDatasSelect()
                    })
                })
            }
        }else{
            Alert.WarningCallback("เลือก Supervisor หรือ ปี ก่อนกดบันทึก")
        }
    }
    renderListInputMonth = ()=> {
        return this.state.datasInput.map((data,index)=>{
            return  <GridContainer key={data.targetAmountID+"-"+index}>
                        <GridItem xs={12} sm={2}>
                            <FormLabel className={this.props.classes.labelHorizontal+" cant-click txt-c-b1"}>
                                {this.convertMonth(data.monthID)}
                            </FormLabel>
                        </GridItem>
                        <GridItem xs={6} sm={5}>
                            <CustomInput
                            formControlProps={{
                                fullWidth: true
                            }}
                            inputProps={{
                                type: "number",
                                value:data.amount_2,
                                onChange:(e)=>this.handleChangeTarget("amount_2",index,e.target.value)
                            }}
                            helpText="เป้าหมาย-รอง"
                            />
                        </GridItem>
                        <GridItem xs={6} sm={5}>
                            <CustomInput
                            formControlProps={{
                                fullWidth: true
                            }}
                            inputProps={{
                                type: "number",
                                value:data.amount_1,
                                onChange:(e)=>this.handleChangeTarget("amount_1",index,e.target.value)
                            }}
                            helpText="เป้าหมาย-หลัก"
                            />
                        </GridItem>
                    </GridContainer>
        })
    }
    totalSettingText = ()=>{
        var a_1 = 0
        var a_2 = 0
        this.state.datasInput.forEach(element => {
            // console.log(element.amount_1,element.amount_2);
            a_1 += parseInt(element.amount_1)
            a_2 += parseInt(element.amount_2)
        });
        return (<div className={"txt-c-b1"}>ยอดรวมเป้าหมาย-รอง ทั้งปี : <span className={"txt-c-bu"}>{thaiBath(a_2,false)}</span> บาท , ยอดรวมเป้าหมาย-หลัก ทั้งปี : <span className={"txt-c-g"}>{thaiBath(a_1,false)}</span> บาท</div>)
    }
    render() {
        const { classes } = this.props;
        return (
            <div className={classes.container2 + " fullWidth"}>
                <Card>
                    <CardBody>
                        <GridContainer justify="center">
                            <GridItem xs={12} sm={12} md={11}>
                                <h4>ตั้งค่าในการแสดง Dashboard</h4>
                            </GridItem>
                            <GridItem xs={12} sm={12} md={11}>
                                <GridContainer>
                                    <GridItem xs={12} sm={6} md={6} lg={6}>
                                        <FormControl
                                        fullWidth
                                        className={classes.selectFormControl}
                                        >
                                        <InputLabel
                                            htmlFor="simple-select"
                                            className={classes.selectLabel}
                                        >
                                            เลือก Supervisor
                                        </InputLabel>
                                        <Select
                                            MenuProps={{
                                            className: classes.selectMenu
                                            }}
                                            classes={{
                                            select: classes.select
                                            }}
                                            value={(this.state.supID!==0?this.state.supID:"")}
                                            onChange={this.handleChangeName}
                                            inputProps={{
                                            name: "supID"
                                            }}
                                        >
                                            <MenuItem
                                            disabled
                                            classes={{
                                                root: classes.selectMenuItem
                                            }}
                                            >
                                                เลือก...
                                            </MenuItem>
                                            {(this.state.supLists.length > 0)?this.renderSupLists():""}
                                        </Select>
                                        </FormControl>
                                    </GridItem>
                                    <GridItem xs={12} sm={6} md={6} lg={6}>
                                        <FormControl
                                        fullWidth
                                        className={classes.selectFormControl}
                                        >
                                        <InputLabel
                                            htmlFor="simple-select"
                                            className={classes.selectLabel}
                                        >
                                            เลือกปีที่ต้องการตั้งค่า
                                        </InputLabel>
                                        <Select
                                            MenuProps={{
                                            className: classes.selectMenu
                                            }}
                                            classes={{
                                            select: classes.select
                                            }}
                                            value={(this.state.yearID!==0?this.state.yearID:"")}
                                            onChange={this.handleChangeName}
                                            inputProps={{
                                            name: "yearID"
                                            }}
                                        >
                                            <MenuItem
                                            disabled
                                            classes={{
                                                root: classes.selectMenuItem
                                            }}
                                            >
                                                เลือก...
                                            </MenuItem>
                                            {(this.state.yearLists.length > 0)?this.renderYearLists():""}
                                        </Select>
                                        </FormControl>
                                    </GridItem>
                                    <GridItem xs={12}>
                                        <hr/>
                                        <h5>{this.totalSettingText()}</h5>
                                        <hr/>
                                    </GridItem>
                                    <GridItem xs={12}>
                                        <div className={"scoll46-page"}>
                                            {(this.state.datasInput.length > 0)?this.renderListInputMonth():""}
                                        </div>
                                    </GridItem>
                                </GridContainer>
                            </GridItem>
                            <GridItem xs={4}>
                                <Button color="info" size="sm" className={classes.marginRight} onClick={(e)=>this.saveAmountTarget()}>
                                    <SaveIcon className={classes.icons} /> บันทึก
                                </Button>
                            </GridItem>
                            <GridItem xs={8}>
                                {
                                    (this.state.dataWaitToSave)?
                                    <div className="txt-c-y"><PriorityHighIcon/> ข้อมูลมีการเปลี่ยนแปลงแล้ว!</div>:""
                                }
                            </GridItem>
                        </GridContainer>
                    </CardBody>
                </Card>
            </div>
        );
    }
}

export default withStyles(styles)(SetAmountTargetPage);
